import { AxiosStatic } from "axios";
import { AxiosInterceptedResult } from "../interceptors";

export interface IPackagesApi {
  readonly getReleaseLineClientPackages: (accountId: string) => Promise<AxiosInterceptedResult<string[]>>;
}

export interface IPackageApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export default class PackagesApi implements IPackagesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IPackageApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getReleaseLineClientPackages = (accountId: string) => {
    return this.axios.get(`${this.apiRoot}/collections/releaseLines/available`, {
      params: { activeUser: accountId },
    }) as Promise<AxiosInterceptedResult<string[]>>;
  };
}
